import { createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50d32406")

_pushScopeId("data-v-50d32406")
const _hoisted_1 = { class: "SuccessOrder" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "SuccessOrder__text" }, "Поздравляем,", -1)
const _hoisted_3 = { class: "SuccessOrder__text" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Накладные добавлены")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Ваш заказ создан")
const _hoisted_6 = { class: "SuccessOrder__actions" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" В мои накладные ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Вернуться в заказ ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Создать новый заказ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("p", _hoisted_3, [
      (_ctx.isUpdate)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _hoisted_4
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _hoisted_5
          ], 64))
    ]),
    _createVNode("div", _hoisted_6, [
      (!_ctx.isUpdate)
        ? (_openBlock(), _createBlock(_component_s_button, {
            key: 0,
            class: "white",
            onClick: _ctx.goInInvoices
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_s_button, {
            key: 1,
            class: "white",
            onClick: _ctx.goInOrder
          }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"])),
      (!_ctx.isUpdate)
        ? (_openBlock(), _createBlock(_component_s_button, {
            key: 2,
            class: "white",
            onClick: _ctx.emitReset
          }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
})